import {BrowserRouter} from "react-router-dom";
import NavBar from "./components/NavBar";
import AppRouter from "./components/AppRouter";
import Footer from "./components/Footer";
import ScrollUp from "./components/ScrollUp";
import ScrollToTop from "./components/ScrollToTop";
import {ToastContainer} from "react-toastify";

function App() {
  return (
    <BrowserRouter>
        <ScrollToTop/>
        <NavBar/>
        <AppRouter/>
        <ToastContainer />
        <ScrollUp/>
        <Footer/>
    </BrowserRouter>
  );
}

export default App;
